// simple-request化（storeeel-infra#2）: current_url はクエリパラメータで送るため、
// エンコード後のリクエストURL全長が中間層の上限（8,192字）を超えないよう切り詰める。
// ホスト・パスはURL先頭にあるので、失われるのは末尾のクエリパラメータのみ
// （本番実測30日・318万PVで raw 4,000字超は4件。最長は広告パラメータが堆積した検索URL）。
export const CURRENT_URL_MAX_ENCODED_LENGTH = 6000;

// サロゲートペアの途中で切ると encodeURIComponent が URIError を投げるため、
// 末尾が上位サロゲート単独になった場合はもう1文字削る
const sliceAvoidingBrokenSurrogate = (value, end) => {
  const sliced = value.slice(0, end);
  const lastCode = sliced.charCodeAt(sliced.length - 1);
  return lastCode >= 0xd800 && lastCode <= 0xdbff ? sliced.slice(0, -1) : sliced;
};

export const truncateUrlForQuery = (url, maxEncodedLength = CURRENT_URL_MAX_ENCODED_LENGTH) => {
  if (typeof url !== 'string') return url;
  if (encodeURIComponent(url).length <= maxEncodedLength) return url;

  // エンコード後長は元の文字数に対して単調増加なので、上限に収まる最大の切り詰め位置を二分探索する
  let low = 0;
  let high = url.length - 1;
  while (low < high) {
    const mid = Math.ceil((low + high) / 2);
    if (encodeURIComponent(sliceAvoidingBrokenSurrogate(url, mid)).length <= maxEncodedLength) {
      low = mid;
    } else {
      high = mid - 1;
    }
  }
  return sliceAvoidingBrokenSurrogate(url, low);
};
